import HeroSlider        from '../components/HeroSlider/HeroSlider';
import HeroSimple        from './hero/HeroSimple';
import CategoryGrid      from '../components/CategoryGrid/CategoryGrid';
import CategoryList      from './categories/CategoryList';
import FeaturedProducts  from '../components/FeaturedProducts/FeaturedProducts';
import ProductCarousel   from './products/ProductCarousel';
import ProductGrid       from './products/ProductGrid';
import BannerSection     from '../components/BannerSection/BannerSection';
import TestimonialSection from '../components/TestimonialSection/TestimonialSection';
import NewsletterSection  from '../components/NewsletterSection/NewsletterSection';
import WhyChooseSection   from '../components/WhyChooseSection/WhyChooseSection';
import PartnersSection    from '../components/PartnersSection/PartnersSection';
import BlogSection        from '../components/BlogSection/BlogSection';
import ContactPage        from '../components/ContactPage/ContactPage';
import ShopByAge          from '../components/ShopByAge/ShopByAge';

import META from './registry.json';

const COMPONENTS = {
  'hero-slider':       HeroSlider,
  'hero-simple':       HeroSimple,
  'category-grid':     CategoryGrid,
  'category-list':     CategoryList,
  'featured-products': FeaturedProducts,
  'product-carousel':  ProductCarousel,
  'product-grid':      ProductGrid,
  'banner':            BannerSection,
  'testimonials':      TestimonialSection,
  'newsletter':        NewsletterSection,
  'why-choose':        WhyChooseSection,
  'partners':          PartnersSection,
  'blog':              BlogSection,
  'contact-page':      ContactPage,
  'shop-by-age':       ShopByAge,
};

export const TEMPLATE_REGISTRY = META.map((meta) => ({
  ...meta,
  component: COMPONENTS[meta.id] ?? null,
}));

export const TEMPLATE_CATEGORIES = ['All', ...new Set(META.map((t) => t.category))];

export function getTemplate(id) {
  return TEMPLATE_REGISTRY.find((t) => t.id === id) ?? null;
}
